import { defineSlotRecipe } from "@chakra-ui/react/styled-system";
import { dialogAnatomy } from "@chakra-ui/react/anatomy";

export default defineSlotRecipe({
  slots: dialogAnatomy.keys(),
  base: {
    header: {
      fontWeight: "bold",
      fontSize: "lg",
    },
    backdrop: {
      bg: "blackAlpha.500",
      _dark: {
        bg: "blackAlpha.300",
      },
    },
  },
  variants: {
    variant: {
      // Export Conversation: a grid, not a row, because the number of export
      // destinations is unbounded.
      exportOptions: {
        body: {
          display: "grid",
          gridTemplateColumns: {
            base: "1fr",
            md: "repeat(auto-fit, minmax(14rem, 1fr))",
          },
          gap: "4",
        },
      },
    },
    size: {
      full: {
        content: {
          borderRadius: "0",
        },
      },
    },
  },
});
